
import moment from 'moment';
import './index.less';

const today = moment().format('YYYY-MM-DD');
const NEW_MONTHS = 3;

const NewIcon = ({cdate}) => {
    // console.log('NewIcon cdate:', cdate);
    
    if (!cdate) return null;
    else {
        const mcdate = moment(cdate, 'YYYY-MM-DD', true).add(NEW_MONTHS, 'months').format('YYYY-MM-DD');
        if (today > mcdate) return null;
        else return <div className='new-icon'>NEW</div>
    }

};

export default NewIcon;
